module.exports = __webpack_public_path__ + "img/study.ff5bf0d2.svg";